import { authHeaders, invokeApi, postRequest } from "../components/network/apiclient";
import { gameExtractionEndpoint } from "./endpoint";

export const extractGames = (token, onSuccess, onError, game_filters, game_negative_filters, num_extraction) =>
    invokeApi(postRequest(gameExtractionEndpoint.extractPath(), authHeaders(token), { game_filters, game_negative_filters, num_extraction }), onSuccess, onError);

export const retrieveExtractions = (token, onSuccess, onError, page_number) =>
    invokeApi(postRequest(gameExtractionEndpoint.retrievePath(), authHeaders(token), { page_number }), onSuccess, onError);

export const deleteExtraction = (token, onSuccess, onError, game_extraction_id) =>
    invokeApi(postRequest(gameExtractionEndpoint.deletePath(), authHeaders(token), { game_extraction_id }), onSuccess, onError);

export const selectGame = (token, onSuccess, onError, game_extraction_id, game_extraction_result_id, selected) =>
    invokeApi(postRequest(gameExtractionEndpoint.selectGamePath(), authHeaders(token), { game_extraction_id, game_extraction_result_id, selected }), onSuccess, onError);
